import {createI18n} from "vue-i18n";
import zhLocale from "./zh-CN";
import esLocale from "./es";
export const messages = {
  "zh-CN": {
    ...zhLocale,
  },
  es: {
    ...esLocale,
  },
};
export const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem("language") || "es",
  messages,
});

export const t = i18n.global.t;
